<template>
  <el-dialog
    append-to-body
    :visible.sync="visible"
    v-if="visible"
    width="80%"
    top="4vh"
    center
    class="Dialog"
    title="应付结算单"
  >
    <div class="dialog-content">
      <sirui-search
        ref="storeDataSearch"
        :query="query"
        :columns="searchFormColumns"
        @resetBtnClick="resetBtnClickHandler"
        @searchBtnClick="queryBtnClickHandler"
      ></sirui-search>
      <div class="main-content">
        <vxe-grid
          show-footer
          :footer-method="footerMethod"
          border
          show-overflow
          resizable
          ref="deductionDialogRef"
          class="vxe-table-element"
          size="mini"
          align="center"
          :auto-resize="true"
          :data="tableData"
          :toolbar="{}"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          @select-change="handleSelectionChange"
          @select-all="handleSelectionChange"
          :valid-config="{ autoPos: true, message: 'inline' }"
          height="300"
        >
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :type="item.type"
            :fixed="item.fixed"
            :field="item.field"
            :title="item.title"
            :width="item.width"
            :sortable="item.sortable"
            :edit-render="item.editRender"
          >
            <template v-slot:edit="{ row }">
              <!-- 计算说明 -->
              <el-input-number
                :precision="2"
                :controls="false"
                v-if="item.editRender.name == 'realityDeductionAmount'"
                v-model="row[item.field]"
                @input="() => handleChange(row, item.field)"
              ></el-input-number>
            </template>
          </vxe-table-column>
        </vxe-grid>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" style="margin-top: 15px" @click="visible = false">取消</el-button>
        <el-button
          type="primary"
          style="margin-top: 15px"
          @click="deductionHandler"
          :disabled="!deductAllPrice"
          >确定抵扣</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { searchColumns, defaultTableColumn } from './index.js';
  // , tableList
  import PAYABLES_TRADE from '@/api/receivablesAndPayables/trade.js';

  export default {
    props: {},
    data() {
      return {
        load: false,
        menuButtonList: [], // 表格功能按钮
        selectionList: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        columnList: defaultTableColumn,
        query: {
          payeeNo: '',
          purchaseOrderNoStr: '',
          paymentApplyNumber: '',
          payeeName: '',
          payableSettlementNo: '',
        },
        visible: false,
        deductAllPrice: null,
        outerOriginalTotalAmount: null, //基本信息中原币结算金额
      };
    },
    computed: {
      searchFormColumns() {
        return searchColumns(this);
      },
    },
    mounted() {
      this.getTableData();
      console.log(this.deductAllPrice, 'deductAllPrice');
    },
    methods: {
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['requestAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            if (['paidAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            if (['deductionAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            if (['realityDeductionAmount'].includes(column.property)) {
              this.deductAllPrice = this.sumNum(data, column.property);
              return this.sumNum(data, column.property);
            }
            return null;
          }),
        ];
      },
      sumNum(list, field) {
        let count = 0;
        list.forEach((item) => {
          count += Number(item[field]);
        });
        return count > 0 ? count.toFixed(2) : 0;
      },
      handleChange(row, field) {
        console.log(row, field, '行');
        if (field === 'realityDeductionAmount') {
          if (row['realityDeductionAmount'] > row['deductionAmount']) {
            this.$message.error('本次抵扣金额不能大于可抵扣金额');
            row['realityDeductionAmount'] = '';
          }
        }
        console.log(this.deductAllPrice, 'deductAllPrice');
      },

      openDialog() {
        this.visible = true;
        this.getTableData();
      },

      // 获取表格数据
      async getTableData() {
        this.selectionList = []; //初始化选中数据
        console.log('搜索');
        const postData = {
          ...this.query,
          approvFalg: '1',
        };
        // this.$refs.siruiTable.page.pageNum,
        // this.$refs.siruiTable.page.pageSize,
        const { data } = await this.$axios.post(
          PAYABLES_TRADE.PAYBLES_DEDUCTION_LIST_API,
          postData
        );
        // const { data } = await this.$axios.post(
        //   'http://10.173.92.58:8020/payableSettlementDeductionDetail/list',
        //   postData
        // );
        // console.log(data, 'ca555555555');
        // this.tableData = tableList;
        if (data.code === 0) {
          // this.tableData = tableList;
          this.tableData = data.data || [];
        }
      },
      // 表格选择行
      handleSelectionChange({ selection }) {
        // console.log(selection, '选择行');
        this.selectionList = selection;
      },
      //确认抵扣
      deductionHandler() {
        console.log(this.selectionList, 'this.selectionList');
        if (!this.selectionList.length) {
          this.$message.error('请选择要抵扣的行信息');
          return;
        }
        let deductAll = 0; // 结算数量
        for (const item of this.selectionList) {
          deductAll += +item['realityDeductionAmount'];
        }
        if (deductAll > this.outerOriginalTotalAmount) {
          this.$message.error('抵扣金额不可大于原币结算总金额（含税）');
          return;
        }

        this.$emit('deductionDialogHandler', this.selectionList, deductAll);
        this.visible = false;
      },
      // 搜索
      queryBtnClickHandler() {
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        this.getTableData();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    padding-bottom: 5px;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 25px;
      padding: 10px;
      border-bottom: 2px solid #ddd;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
  }
  ::v-deep {
    .el-dialog__body {
      padding: 15px 20px !important;
    }
    .vxe-toolbar {
      display: none;
    }
    .vxe-grid {
      margin-top: 60px;
    }
  }
</style>
